var e={lightTheme:{MuiSelect:{styleOverrides:{outlined:{padding:"7.5px 14px"}}}}};export{e as default};